import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container-full-5 p-5" }
const _hoisted_2 = {
  key: 0,
  class: "alert alert-danger mb-4"
}
const _hoisted_3 = { class: "s20 widget px-6 pt-6 pb-3 mb-5" }
const _hoisted_4 = { class: "container-full-2 s20 my-3 flex gap-3" }
const _hoisted_5 = { class: "s7" }
const _hoisted_6 = { class: "s5" }
const _hoisted_7 = {
  key: 1,
  class: "flex-center py-10"
}
const _hoisted_8 = {
  key: 2,
  class: "s20 widget pb-2"
}
const _hoisted_9 = { class: "table separator skin3 rounded" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex-right" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 0,
  class: "text-center mt-4 mb-4"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "mx-3" }
const _hoisted_16 = ["disabled"]

import { ref, reactive, onMounted } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'KycMembresList',
  setup(__props) {

const router = useRouter()
const loading = ref(false)
const errorMessage = ref('')
const members = ref<any[]>([])
const filters = reactive({
  search: '',
  statut_kyc: '',
})
const pagination = reactive({
  pageNumber: 1,
  pageSize: 10,
  total: 0,
  last_page: 1,
})

async function fetchMembers() {
  loading.value = true
  errorMessage.value = ''
  try {
    const params: Record<string, any> = {
      pageNumber: pagination.pageNumber,
      pageSize: pagination.pageSize,
    }
    if (filters.search) params.search = filters.search
    if (filters.statut_kyc) params.statut_kyc = filters.statut_kyc
    const { data } = await axios.get('/kyc/members', { params })
    members.value = data.data || []
    pagination.total = data.total || 0
    pagination.last_page = data.last_page || 1
  } catch (e: any) {
    errorMessage.value = e.response?.data?.message || 'Erreur lors du chargement des membres'
  } finally {
    loading.value = false
  }
}

function applyFilters() {
  pagination.pageNumber = 1
  fetchMembers()
}

function goToDetail(member: any) {
  router.push({ name: 'collectivites-kyc-membre-detail', params: { id: member.id } })
}

function statutLabel(member: any): { label: string; cls: string } {
  const statut = member?.kyc?.statut
  if (!member?.kyc) return { label: 'Non rempli', cls: 'tag-state warning stroke' }
  if (statut === 'verified') return { label: 'Validé', cls: 'tag-state success stroke' }
  if (statut === 'rejected') return { label: 'Rejeté', cls: 'tag-state danger stroke' }
  return { label: 'En attente', cls: 'tag-state warning stroke' }
}

onMounted(fetchMembers)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "secondary-font gap-4 mt-2 mb-6" }, "KYC des membres", -1)),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            placeholder: "Rechercher (nom, email)",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.search) = $event)),
            onKeyup: _withKeys(applyFilters, ["enter"])
          }, null, 544), [
            [_vModelText, filters.search]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("select", {
            class: "form-input-select",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.statut_kyc) = $event)),
            onChange: applyFilters
          }, [...(_cache[4] || (_cache[4] = [
            _createStaticVNode("<option value=\"\">Tous statuts KYC</option><option value=\"pending\">En attente</option><option value=\"verified\">Validé</option><option value=\"rejected\">Rejeté</option><option value=\"no_kyc\">Pas de KYC</option>", 5)
          ]))], 544), [
            [_vModelSelect, filters.statut_kyc]
          ])
        ]),
        _createElementVNode("button", {
          class: "btn normal",
          onClick: applyFilters
        }, "Filtrer")
      ])
    ]),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("div", { class: "loader dark" }, null, -1)
        ]))]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Membre"),
                _createElementVNode("th", null, "Email"),
                _createElementVNode("th", null, "Téléphone"),
                _createElementVNode("th", null, "Statut KYC"),
                _createElementVNode("th")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (members.value.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("td", {
                      colspan: "5",
                      class: "text-center text-grey-500 py-5"
                    }, "Aucun membre trouvé", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(members.value, (m) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: m.id,
                  class: "over-effect"
                }, [
                  _createElementVNode("td", null, _toDisplayString(m.nom) + " " + _toDisplayString(m.prenom), 1),
                  _createElementVNode("td", null, _toDisplayString(m.email), 1),
                  _createElementVNode("td", null, _toDisplayString(m.telephone), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("span", {
                      class: _normalizeClass(statutLabel(m).cls)
                    }, _toDisplayString(statutLabel(m).label), 3)
                  ]),
                  _createElementVNode("td", _hoisted_11, [
                    _createElementVNode("button", {
                      class: "btn white2 active",
                      onClick: ($event: any) => (goToDetail(m))
                    }, " Gérer ", 8, _hoisted_12)
                  ])
                ]))
              }), 128))
            ])
          ]),
          (pagination.total > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("button", {
                  class: "btn",
                  disabled: pagination.pageNumber <= 1,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ((pagination.pageNumber--, fetchMembers())))
                }, " Précédent ", 8, _hoisted_14),
                _createElementVNode("span", _hoisted_15, "Page " + _toDisplayString(pagination.pageNumber) + " / " + _toDisplayString(pagination.last_page), 1),
                _createElementVNode("button", {
                  class: "btn",
                  disabled: pagination.pageNumber >= pagination.last_page,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => ((pagination.pageNumber++, fetchMembers())))
                }, " Suivant ", 8, _hoisted_16)
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})